import { render, staticRenderFns } from "./take.vue?vue&type=template&id=e671221e&scoped=true&"
import script from "./take.vue?vue&type=script&lang=js&"
export * from "./take.vue?vue&type=script&lang=js&"
import style0 from "./take.vue?vue&type=style&index=0&id=e671221e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e671221e",
  null
  
)

export default component.exports